module.exports = "/fonts/FiraSans-BlackItalic.ttf";